"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.split");
var _axios = _interopRequireDefault(require("axios"));
var _validate = require("@/utils/validate");
var _clipboard = _interopRequireDefault(require("@/utils/clipboard"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var _this = this;
    var validateConfigItemName = function validateConfigItemName(rule, value, callback) {
      if ((0, _validate.validRule1)(value)) {
        callback(new Error(_this.$t('configuration.error.configItemName')));
      } else if (_this.errorKeys.indexOf('configItemName_empty') >= 0) {
        callback(new Error(_this.errorInfo['configItemName_empty']));
        _this.resetError('configItemNameEmpty');
      } else {
        callback();
      }
    };
    var validateIsNumber = function validateIsNumber(rule, value, callback) {
      if (value === '') {
        return callback(new Error(_this.$t('configuration.error.isNotValueEmpty')));
      }
      if (!(0, _validate.isNumber)(value)) {
        callback(new Error(_this.$t('configuration.error.itemIsMember')));
      } else {
        callback();
      }
    };
    var validateItemDetailCode = function validateItemDetailCode(rule, value, callback) {
      var isRepeatValue = null;
      var tmpArr = rule.field.split('.');
      var key = Number("".concat(tmpArr[1]));
      var newConfigItemDetailMultiValVoList = _this.form.configItemDetailMultiValVoList;
      newConfigItemDetailMultiValVoList.forEach(function (element, index) {
        if (key !== index) {
          if (element.itemDetailCode !== '') {
            if (element.value !== '') {
              isRepeatValue = element.itemDetailCode === value;
            }
          }
        }
      });
      if (!value) {
        callback(new Error(_this.$t('configuration.error.itemDetailCode')));
      } else if (isRepeatValue) {
        callback(new Error(_this.$t('configuration.error.repeat')));
      } else if (_this.errorKeys.indexOf('itemDetailCode') >= 0) {
        callback(new Error(_this.errorInfo['itemDetailCode']));
        _this.resetError('itemDetailCode');
      } else {
        callback();
      }
    };
    return {
      count: 4,
      configuraType: '',
      pageName: 'configuration',
      formLabelWidth: '100px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      isShowModel: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      dialogStatus: 'edit',
      form: {
        configItem: {
          configItemCode: ''
        },
        configItemDetailMultiValVoList: []
      },
      initForm: {
        configItem: {},
        configItemDetailMultiValVoList: [{}]
      },
      rules: {
        configItemName: [{
          required: true,
          trigger: ['change'],
          validator: validateConfigItemName
        }],
        itemDetailCode: [{
          required: true,
          trigger: ['change'],
          validator: validateItemDetailCode
        }],
        validateItemDetailSn: [{
          required: true,
          trigger: ['change'],
          validator: validateIsNumber
        }]
      },
      errorKeys: [],
      errorInfo: {},
      searchVal: {
        configItemCode: '',
        configItemName: '',
        configItemType: '',
        configItemStatus: ''
      },
      configItem: {},
      singleForm: {
        valueCN: '',
        valueEN: ''
      },
      formLoading: false,
      lookupList: {},
      languageAllData: [],
      newConfigItemDetailMultiValVoList: []
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode();
    }
  },
  mounted: function mounted() {
    this.getLookupTypeCode();
    this.getLanguageInfoQueryAll();
  },
  methods: {
    roleAuth: function roleAuth() {},
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          configItemCode: this.searchVal.configItemCode,
          configItemName: this.searchVal.configItemName,
          configItemType: this.searchVal.configItemType,
          configItemStatus: this.searchVal.configItemStatus
        }
      };
      this.listLoading = true;
      this.$api.configuaration.getConfigList(param).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        console.log('-------', err);
        _this2.listLoading = false;
      });
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    edit: function edit(row) {
      var _this3 = this;
      // 临时
      this.configuraType = '';
      this.dialogStatus = 'edit';
      this.configItem = row;
      this.currentId = row.configItemPk;
      this.isShowModel = true;
      this.formLoading = true;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this3.isShowModel = true;
        _this3.formLoading = false;
        _this3.$nextTick(function () {
          _this3.$refs['dataForm'].clearValidate();
        });
      });
    },
    getDetail: function getDetail() {
      var _this4 = this;
      return new Promise(function (resolve) {
        _this4.isLoading = true;
        _this4.$api.configuaration.getConfigById(_this4.currentId).then(function (res) {
          _this4.isLoading = false;
          var _res$data = res.data,
            _res$data$configItem = _res$data.configItem,
            configItem = _res$data$configItem === void 0 ? {} : _res$data$configItem,
            _res$data$configItemD = _res$data.configItemDetailMultiValVoList,
            configItemDetailMultiValVoList = _res$data$configItemD === void 0 ? [] : _res$data$configItemD;
          var newConfigItemDetailMultiValVoList = _this4.configItemDetailMultiValVoListHandle(configItemDetailMultiValVoList);
          _this4.form = {
            configItem: configItem,
            configItemDetailMultiValVoList: newConfigItemDetailMultiValVoList
          };
          _this4.initForm = {
            configItem: configItem,
            configItemDetailMultiValVoList: configItemDetailMultiValVoList
          };
          resolve(_this4.form);
        }).catch(function (err) {
          console.log(err, 'err');
          _this4.isLoading = false;
          console.log('Data Request Fail');
        });
      });
    },
    configItemDetailMultiValVoListHandle: function configItemDetailMultiValVoListHandle(configItemDetailMultiValVoList) {
      var _this5 = this;
      if (configItemDetailMultiValVoList && configItemDetailMultiValVoList.length > 0) {
        var _loop = function _loop() {
          var detailLanguageValList = configItemDetailMultiValVoList[item].detailLanguageValList;
          if (_this5.languageAllData && _this5.languageAllData.length > 0) {
            if (detailLanguageValList && detailLanguageValList.length > 0 && detailLanguageValList.length !== _this5.languageAllData.length) {
              var newLanguageArr;
              for (var k = 0; k < _this5.languageAllData.length; k++) {
                var _this5$languageAllDat = _this5.languageAllData[k],
                  languageCode = _this5$languageAllDat.languageCode,
                  languageStatus = _this5$languageAllDat.languageStatus;
                var isExist = false;
                for (var j = 0; j < detailLanguageValList.length; j++) {
                  newLanguageArr = [];
                  if (languageStatus === 'ENABLED') {
                    if (detailLanguageValList[j].language === languageCode) {
                      isExist = true;
                      break;
                    }
                    if (!isExist) {
                      newLanguageArr.push({
                        language: languageCode,
                        value: ''
                      });
                    }
                  }
                }
              }
              if (newLanguageArr && newLanguageArr.length > 0) {
                newLanguageArr.forEach(function (item) {
                  detailLanguageValList.push(item);
                });
              }
            }
          }
        };
        for (var item = 0; item < configItemDetailMultiValVoList.length; item++) {
          _loop();
        }
      }
      return configItemDetailMultiValVoList !== null ? configItemDetailMultiValVoList : [];
    },
    saveItem: function saveItem() {
      var _this6 = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        var _this6$form$configIte = _this6.form.configItem,
          configItemCode = _this6$form$configIte.configItemCode,
          configItemName = _this6$form$configIte.configItemName,
          configItemType = _this6$form$configIte.configItemType,
          configItemDetailType = _this6$form$configIte.configItemDetailType,
          configItemPk = _this6$form$configIte.configItemPk;
        var detailValParamList = [];
        _this6.form.configItemDetailMultiValVoList.forEach(function (item) {
          detailValParamList.push({
            itemDetailCode: item.itemDetailCode ? item.itemDetailCode : configItemCode,
            detailLanguageValList: item.detailLanguageValList,
            configItemPk: configItemPk,
            itemDetailSn: item.itemDetailSn
          });
        });
        var form = {
          configItemPk: configItemPk,
          configItemCode: configItemCode,
          configItemName: configItemName,
          configItemType: configItemType,
          configItemDetailType: configItemDetailType,
          detailValParamList: detailValParamList
        };
        _this6.$confirm(_this6.$t('common.confirm14'), _this6.$t('common.tip'), {
          confirmButtonText: _this6.$t('common.confirm'),
          cancelButtonText: _this6.$t('common.cancel'),
          type: 'warning'
        }).then(function () {
          _this6.isLoading = true;
          _this6.$api.configuaration.savaConfig(form).then(function (res) {
            _this6.isLoading = false;
            _this6.isShowModel = false;
            _this6.$message.success(_this6.$t('common.saveSuccess'));
            _this6.refreshData();
          }).catch(function (err) {
            if (err.errorInfos && err.errorInfos.length > 0) {
              _this6.resetError();
              err.errorInfos.forEach(function (item) {
                _this6.errorKeys.push(item.key);
                _this6.errorInfo[item.key] = item.errMsg;
              });
              _this6.$refs['dataForm'].validate(function (valid) {
                console.log(valid);
              });
            }
            _this6.isLoading = false;
            // this.$message.error('保存失败')
          });
        }).catch(function () {
          // console.log(err, 'err')
        });
      });
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    updateStatus: function updateStatus(configItem) {
      var _this7 = this;
      this.$confirm(configItem.configItemStatus === 'ENABLED' ? this.$t("common.confirm2") : this.$t("common.confirm3"), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        var params = {
          configItemPk: configItem.configItemPk,
          configItemCode: configItem.configItemCode,
          configItemStatus: configItem.configItemStatus === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        };
        _this7.$api.configuaration.updateStatus(params).then(function (res) {
          _this7.$message.success(_this7.$t('common.updateSuccess'));
          _this7.refreshData();
        }).catch(function () {
          _this7.isLoading = false;
          // this.$message.error('保存失败')
        });
      }).catch(function () {});
    },
    addValue: function addValue(form) {
      var _form$configItem = form.configItem,
        configItemCode = _form$configItem.configItemCode,
        configItemName = _form$configItem.configItemName,
        configItemType = _form$configItem.configItemType,
        configItemDetailType = _form$configItem.configItemDetailType;
      var detailLanguageValList = [];
      this.languageAllData.forEach(function (item) {
        var languageCode = item.languageCode,
          languageStatus = item.languageStatus;
        if (languageStatus === 'ENABLED') {
          detailLanguageValList.push({
            language: languageCode,
            value: ''
          });
        }
      });
      this.form.configItemDetailMultiValVoList.push({
        configItemCode: configItemCode,
        configItemName: configItemName,
        configItemType: configItemType,
        configItemDetailType: configItemDetailType,
        itemDetailCode: '',
        itemDetailSn: this.tableIndex(this.form.configItemDetailMultiValVoList.length),
        detailLanguageValList: detailLanguageValList
      });
      this.languageMappingHandleClick();
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this8 = this;
      var param = {
        configItemCodeList: ['CONFIGURATION_STATUS', 'CONFIGURATION_TYPE']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        _this8.lookupList = JSON.parse(JSON.stringify(res.data || {}));
        // 查找值数据转换
        for (var key in _this8.lookupList) {
          _this8.generateMapping(key, _this8.lookupList[key] || []);
        }
        _this8.searchData();
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      });
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this9 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this9.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    },
    resetData: function resetData() {
      this.searchVal = {
        configItemCode: '',
        configItemName: '',
        configItemType: '',
        configItemStatus: ''
      };
      this.fetchData();
    },
    deleteValue: function deleteValue(index) {
      var _this0 = this;
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        if (_this0.form.configItemDetailMultiValVoList.length === 1) {
          return _this0.$message.error('至少保留一条数据');
        }
        _this0.form.configItemDetailMultiValVoList.splice(index, 1);
        _this0.$message.success(_this0.$t('common.deleteSuccess'));
      }).catch(function () {});
    },
    celldblclick: function celldblclick(row, column, cell, event) {
      // const _this = this
      (0, _clipboard.default)(event.target.innerText, event);
    },
    // 新增add方法
    addConfiguration: function addConfiguration(type) {
      var _this1 = this;
      this.configuraType = 'add';
      this.dialogStatus = 'edit';
      this.isShowModel = true;
      this.formLoading = true;
      this.form.configItem = {};
      this.form.configItemDetailMultiValVoList = [];
      // this.form.configItem.configItemName = ''

      var detailLanguageValList = [];
      this.languageAllData.forEach(function (item) {
        var languageCode = item.languageCode,
          languageStatus = item.languageStatus;
        if (languageStatus === 'ENABLED') {
          detailLanguageValList.push({
            language: languageCode,
            value: ''
          });
        }
      });
      if (type === '下拉值') {
        this.form.configItem.configItemDetailType = '下拉值';
        this.form.configItem.configItemType = '下拉值';
        this.configItem.configItemType = '下拉值';
      } else if (type === '值') {
        this.form.configItem.configItemDetailType = '值';
        this.form.configItem.configItemType = '值';
        this.configItem.configItemType = '值';
        this.form.configItemDetailMultiValVoList = [{
          detailLanguageValList: detailLanguageValList
        }];
      }
      // this.getDetail().then(res => {
      this.isShowModel = true;
      this.formLoading = false;
      this.$nextTick(function () {
        _this1.$refs['dataForm'].clearValidate();
      });
      // })
    },
    getLanguageInfoQueryAll: function getLanguageInfoQueryAll() {
      var _this10 = this;
      this.$api.configuaration.getLanguageInfoQueryAll().then(function (res) {
        _this10.languageAllData = res.data;
      }).catch(function (err) {
        console.log('-------', err);
        _this10.listLoading = false;
      });
    },
    languageMappingHandleClick: function languageMappingHandleClick() {
      var _this11 = this;
      var languageRule = {};
      this.languageAllData.forEach(function (item) {
        var languageCode = item.languageCode,
          languageStatus = item.languageStatus;
        if (languageStatus === 'ENABLED') {
          languageRule[languageCode] = _this11.valueCN;
        }
      });
      return languageRule;
    },
    valueCN: function valueCN(rule, value, callback) {
      var tmpArr = rule.field.split('.');
      var key = Number("".concat(tmpArr[1]));
      var isRepeatValue = this.validateValue(key, value, 'zh');
      if (!value) {
        callback(new Error(this.$t('configuration.error.valueCN')));
      } else if (isRepeatValue) {
        callback(new Error(this.$t('configuration.error.repeat')));
      } else if (this.errorKeys.indexOf('value') >= 0) {
        callback(new Error(this.errorInfo['value']));
        this.resetError('value');
      } else {
        callback();
      }
    },
    validateValue: function validateValue(key, value, type) {
      var isRepeatValue = null;
      var newConfigItemDetailMultiValVoList = this.form.configItemDetailMultiValVoList;
      newConfigItemDetailMultiValVoList.forEach(function (element, index) {
        if (key !== index) {
          var newDetailLanguageValList = element.detailLanguageValList;
          newDetailLanguageValList.forEach(function (item) {
            if (item.language === type) {
              if (item.value !== '') {
                if (item.value === value) {
                  isRepeatValue = true;
                }
              }
            }
          });
        }
      });
      return isRepeatValue;
    }
  }
};